import { styled } from '@mui/system'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(
  (props) => `
    position: absolute;
    right:0;
    top: calc(50% - 41px);
    z-index:1;
    padding:8px;
    background:#FCF7D4;
    max-width:173px;
    border-radius: 4px 0px 0px 4px;
    & b::before { content:'i'; width:16px; height:16px; border: 1px #000 solid; line-height:16px; border-radius:50%; display:inline-block; margin-right:5px; font-size:11px;  font-weight: 400; }
    & b { font-size: 14px; font-weight: 400; text-align: center;}
    & p { font-size: 11px; font-weight: 400; line-height:13px; padding-top:5px;}
    
    &.large {
      padding:12px;
      max-width:230px;
      & b { font-size: 15px; }
      & p { font-size: 13px; line-height:18px;} }
    }
    
    &.center {
      right:calc(50% - 90px);
    }
`)
